/**
 * Report-Definition für die Ziele-Seite (Standalone). Inhaltlich identisch zur
 * Ziele-Sektion im Projektauftrag, aber als eigenständiges PDF exportierbar.
 */
import { buildDocument, buildSection, textBlock, type ReportDocument } from '../../../lib/pdf/reportModel';

export interface ZieleReportInput {
  zieleHaupt: string;
  zieleTeil: string;
  zieleNicht: string;
  zieleAkzeptanz: string;
  bekannteUnbekannte: string;
}

export function buildZieleReport(input: ZieleReportInput): ReportDocument {
  return buildDocument([
    buildSection('Ziele', [
      textBlock('Hauptziel', input.zieleHaupt),
      textBlock('Meilensteine', input.zieleTeil),
      textBlock('Nicht-Ziele', input.zieleNicht),
      textBlock('Akzeptanzkriterien', input.zieleAkzeptanz),
      textBlock('Bekannte Unbekannte / Risiken', input.bekannteUnbekannte),
    ]),
  ]);
}
